// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/List.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {List, ListItem, view, css} from '@sail/ui';

const Container = ({children}) => (
  <view.div
    css={{
      width: css.value('300px'),
      background: 'surface',
      padding: 'medium',
      borderRadius: 'large',
    }}
  >
    {children}
  </view.div>
);

const basic = {
  rendered: (
    <Container>
      <List
        onAction={(id) => console.log(`Pressed row #${id}`)}
        aria-label="Example of a List"
      >
        <ListItem
          value="$100.00"
          id={1}
          title={<view.div>Payment #1862</view.div>}
          secondaryTitle={
            <view.div slot="description">customer@test.com</view.div>
          }
        />
        <ListItem
          value="$63.00"
          id={2}
          title={<view.div>Payment #9273</view.div>}
          secondaryTitle={
            <view.div slot="description">frank@example.com</view.div>
          }
        />
        <ListItem
          value="$7,471.62"
          id={3}
          title={<view.div>Payment #643</view.div>}
          secondaryTitle={
            <view.div slot="description">robert@google.com</view.div>
          }
        />
        <ListItem
          value="$871.01"
          id={4}
          title={<view.div>Payment #123</view.div>}
          secondaryTitle={
            <view.div slot="description">example@gmail.com</view.div>
          }
        />
      </List>
    </Container>
  ),
  source: `<List
  onAction={(id: string | number) => console.log(\`Pressed row #\${id}\`)}
  aria-label="Example of a List"
>
  <ListItem
    value="$100.00"
    id={1}
    title={<Box>Payment #1862</Box>}
    secondaryTitle={<Box>customer@test.com</Box>}
  />
  <ListItem
    value="$63.00"
    id={2}
    title={<Box>Payment #9273</Box>}
    secondaryTitle={<Box>frank@example.com</Box>}
  />
  <ListItem
    value="$7,471.62"
    id={3}
    title={<Box>Payment #643</Box>}
    secondaryTitle={<Box>robert@google.com</Box>}
  />
  <ListItem
    value="$871.01"
    id={4}
    title={<Box>Payment #123</Box>}
    secondaryTitle={<Box>example@gmail.com</Box>}
  />
</List>`,
};
const items = {
  rendered: (
    <Container>
      <List onAction={(id) => console.log(id)} aria-label="Example of a List">
        <ListItem id="apple" title={<view.div>Apple</view.div>} />
        <ListItem id="orange" title={<view.div>Orange</view.div>} />
        <ListItem id="banana" title={<view.div>Banana</view.div>} />
      </List>
    </Container>
  ),
  source: `<List
  onAction={(id: string | number) => console.log(id)}
  aria-label="Example of a List"
>
  <ListItem id="apple" title={<Box>Apple</Box>} />
  <ListItem id="orange" title={<Box>Orange</Box>} />
  <ListItem id="banana" title={<Box>Banana</Box>} />
</List>`,
};
const secondaryTitle = {
  rendered: (
    <Container>
      <List onAction={(id) => console.log(id)} aria-label="Example of a List">
        <ListItem
          id={1}
          title={<view.div>John Smith</view.div>}
          secondaryTitle={<view.div>johnsmith@test.com</view.div>}
        />
        <ListItem
          id={2}
          title={<view.div>Jane Doe</view.div>}
          secondaryTitle={<view.div>janedoe@test.com</view.div>}
        />
        <ListItem
          id={3}
          title={<view.div>Mark Foster</view.div>}
          secondaryTitle={
            <view.div slot="description">markfoster@test.com</view.div>
          }
        />
      </List>
    </Container>
  ),
  source: `<List
  onAction={(id: string | number) => console.log(id)}
  aria-label="Example of a List"
>
  <ListItem
    id={1}
    title={<Box>John Smith</Box>}
    secondaryTitle={<Box>johnsmith@test.com</Box>}
  />
  <ListItem
    id={2}
    title={<Box>Jane Doe</Box>}
    secondaryTitle={<Box>janedoe@test.com</Box>}
  />
  <ListItem
    id={3}
    title={<Box>Mark Foster</Box>}
    secondaryTitle={<Box>markfoster@test.com</Box>}
  />
</List>`,
};
export const ListExamples = {
  basic,
  items,
  secondaryTitle,
};
